// Define play modes
export enum PlayMode {
  Normal = 'normal',
  Bounce = 'bounce'
};
